<p-panel header="{{config?.labels?.ricercaHeader}}" [toggleable]="true" [style]="{'margin-bottom':'5px'}"
         [(collapsed)]="filterCollapsed" toggler="header" styleClass="w-100"
         *ngIf="config.serverSideFilters && config.searchFields && config.searchFields.length > 0">
  <div class="row">
    <div class="col-xs col-sm col-md col-lg" *ngIf="config.searchFields && config.searchFields.length > 0">
      <div class="card-block bg-white" [hidden]="filterCollapsed">
        <form (ngSubmit)="formFilterQuery()" [formGroup]="formFilter" novalidate>
          <div class="row form-group">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6" *ngFor="let fieldForm of config.searchFields">
              <label class="mb-1 ml-3 mt-2 font-weight-bold">{{ fieldForm.label}}</label>

              <!-- filtro input testo normale "contains" o "in" -->
              <div class="input-group"
                   *ngIf="fieldForm.type == DynTableColFilterType.INPUT_CONTAINS || fieldForm.type == DynTableColFilterType.IN_VAL">
                <input class="form-control mx-3" [placeholder]="fieldForm.placeholder" [formControlName]="fieldForm.name">
              </div>

              <div class="input-group" *ngIf="fieldForm.type == DynTableColFilterType.EQUALS">
                <input class="form-control mx-3" [placeholder]="fieldForm.placeholder" [formControlName]="fieldForm.name">
              </div>


              <p-inputMask *ngIf="fieldForm.type == DynTableColFilterType.TIME_SEARCH"
                           [formControlName]="fieldForm.name" styleClass="form-control" mask="99:99" slotChar="HH:MM"
                           placeholder="HH:MM..." [style]="{'width': '95%', 'margin-right': '1rem', 'margin-left': '1rem'}">
              </p-inputMask>

              <!-- filtro select (dropdown) con ricerca -->
              <div class="input-group px-3" *ngIf="fieldForm.type == DynTableColFilterType.SELECT">
                <ng-select [placeholder]="fieldForm.placeholder" class="w-100" [items]="fieldForm.options"
                           bindValue="value" bindLabel="label" [formControlName]="fieldForm.name"
                           (change)="pickedValueFromSelectFilter($event, fieldForm.name)">
                </ng-select>
              </div>

              <!-- Filtro date-picker su singola data -->
              <div class="input-group" *ngIf="fieldForm.type == DynTableColFilterType.DATE_SEARCH">
                <p-calendar [monthNavigator]="true" [yearNavigator]="true"
                            [style]="{'width': '100%', 'margin-left': '0.5em'}"
                            [inputStyle]="{'height': 'calc(1.5em + 0.75rem)', 'width': '83%'}" yearRange="2001:2040"
                            dateFormat="dd/mm/yy" [showIcon]="true" [formControlName]="fieldForm.name" [showButtonBar]="true"
                            [placeholder]="fieldForm.placeholder" [baseZIndex]="3002"
                            [touchUI]="deviceService.isMobile()" [appendTo]="deviceService.isMobile() ? 'body' : null">
                </p-calendar>
              </div>

              <!-- Filtro date-picker con range di date -->
              <div class="input-group" *ngIf="fieldForm.type == DynTableColFilterType.DATE_RANGE">
                <p-calendar [monthNavigator]="true" [yearNavigator]="true"
                            [style]="{'width': '100%', 'margin-left': '0.5em'}" [placeholder]="fieldForm.placeholder"
                            [inputStyle]="{'height': 'calc(1.5em + 0.75rem)', 'width': '83%'}" selectionMode="range"
                            yearRange="2001:2040" dateFormat="dd/mm/yy" [showIcon]="true" [formControlName]="fieldForm.name"
                            [showButtonBar]="true" [baseZIndex]="3002"
                            [touchUI]="deviceService.isMobile()" [appendTo]="deviceService.isMobile() ? 'body' : null">
                </p-calendar>
              </div>

              <!-- Filtro con range di orario -->
              <ng-template [ngIf]="fieldForm.type == DynTableColFilterType.TIME_RANGE">
                <div class="d-flex w-100">
                  <div class="col-6">
                    <p-inputMask [formControlName]="fieldForm.nameFrom" styleClass="form-control" mask="99:99"
                                 slotChar="HH:MM" placeholder="HH:MM..." [style]="{'width': '100%'}"
                                 (onComplete)="formFilter.controls[fieldForm.nameTo].enable()"
                                 (onInput)="formFilter.controls[fieldForm.nameTo].reset; formFilter.controls[fieldForm.nameTo].disable()">
                    </p-inputMask>
                  </div>
                  <div class="col-6">
                    <p-inputMask [formControlName]="fieldForm.nameTo" styleClass="form-control" mask="99:99"
                                 slotChar="HH:MM" placeholder="HH:MM..." [style]="{'width': '100%'}">
                    </p-inputMask>
                  </div>
                </div>
              </ng-template>

              <ng-template [ngIf]="fieldForm.type == DynTableColFilterType.DATE_INTERVAL">
                <div class="d-flex w-100">
                  <div class="col-6">
                    <p-calendar [monthNavigator]="true" [yearNavigator]="true" styleClass="w-100"
                                yearRange="2001:2040" dateFormat="dd/mm/yy" [showIcon]="true"
                                [placeholder]="fieldForm.placeholder" [formControlName]="fieldForm.nameFrom"
                                [showButtonBar]="true" [baseZIndex]="3002"
                                [appendTo]="deviceService.isMobile() ? 'body' : null"
                                [touchUI]="deviceService.isMobile()"
                                (onClose)="formFilter.controls[fieldForm.nameFrom].value ? formFilter.controls[fieldForm.nameTo].enable() : null"
                                (onClearClick)="formFilter.controls[fieldForm.nameTo].reset();
                                                formFilter.controls[fieldForm.nameTo].disable()">
                    </p-calendar>
                  </div>
                  <div class="col-6">
                    <p-calendar [monthNavigator]="true" [yearNavigator]="true"
                                [minDate]="formFilter.controls[fieldForm.nameFrom].value" styleClass="w-100" yearRange="2001:2040"
                                dateFormat="dd/mm/yy" [showIcon]="true" [formControlName]="fieldForm.nameTo"
                                [showButtonBar]="true" [baseZIndex]="3002"
                                [touchUI]="deviceService.isMobile()" [appendTo]="deviceService.isMobile() ? 'body' : null"
                                [placeholder]="fieldForm.placeholder">
                    </p-calendar>
                  </div>
                </div>
              </ng-template>

              <ng-template [ngIf]="fieldForm.type == DynTableColFilterType.TS_INTERVAL">
                <div class="d-flex w-100">
                  <div class="col-6">
                    <p-calendar [monthNavigator]="true" [yearNavigator]="true" styleClass="w-100"
                                yearRange="2001:2040" dateFormat="dd/mm/yy" [showIcon]="true"
                                [formControlName]="fieldForm.nameFrom" [showButtonBar]="true"
                                [appendTo]="deviceService.isMobile() ? 'body' : null" [baseZIndex]="3002"
                                [touchUI]="deviceService.isMobile()"
                                [placeholder]="fieldForm.placeholder"
                                (onClose)="formFilter.controls[fieldForm.nameFrom].value ? formFilter.controls[fieldForm.nameTo].enable() : null"
                                (onClearClick)="formFilter.controls[fieldForm.nameTo].reset();
                                                formFilter.controls[fieldForm.nameTo].disable()" [showTime]="true">
                    </p-calendar>
                  </div>
                  <div class="col-6">
                    <p-calendar [monthNavigator]="true" [yearNavigator]="true"
                                [minDate]="formFilter.controls[fieldForm.nameFrom].value" styleClass="w-100" yearRange="2001:2040"
                                dateFormat="dd/mm/yy" [showIcon]="true" [formControlName]="fieldForm.nameTo"
                                [showButtonBar]="true" [appendTo]="deviceService.isMobile() ? 'body' : null"
                                [baseZIndex]="3002" [touchUI]="deviceService.isMobile()" [showTime]="true"
                                [placeholder]="fieldForm.placeholder">
                    </p-calendar>
                  </div>
                </div>
              </ng-template>

              <!-- filtro di ricerca del valore in input con chiamata al servizio -->
              <div class="input-group button-input-search ml-3" *ngIf="fieldForm.type == DynTableColFilterType.CALL_WS">
                <input [formControlName]="fieldForm.name" class="form-control" type="text"
                       placeholder="{{fieldForm.placeholder}}">
                <button *ngIf="formFilter.controls[fieldForm.name].value?.length > 0"
                        class="btn btn-primary btn-invisible" type="button"
                        (click)="formFilter.controls[fieldForm.name].setValue(null)">
                  <i class="fas fa-fw fa-times"></i>
                </button>
                <button
                    [disabled]="!formFilter.controls[fieldForm.name].value || formFilter.controls[fieldForm.name].value?.length == 0"
                    class="btn btn-primary" type="button"
                    (click)="researchInputValue(formFilter.controls[fieldForm.name].value, fieldForm.name)">
                  <i class="fas fa-search-plus"></i>
                </button>
              </div>

            </div>
          </div>
          <div class="form-group form-actions ml-3">
            <button [disabled]="!formFilter.valid" type="submit" class="btn btn-sm btn-primary">
              <i class="fas fa-fw fa-search"></i> {{config?.labels?.filtraBtnLabel}}
            </button>
            <button type="button" (click)="resetSearch()" class="btn btn-sm btn-info ml-2">
              <i class="fas fa-fw fa-undo"></i> {{config?.labels?.resetBtnLabel}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</p-panel>

<div [ngClass]="getMargin()">
  <p-table #dynTable [columns]="columns" [value]="data" dataKey="index" [paginator]="config.paginator"
           [totalRecords]="total" [rows]="inputPagination ? inputPagination.size : 10" [rowsPerPageOptions]="[5, 10, 25, 50]"
           [expandedRowKeys]="expandedRows" [lazy]="!config.clientManagedTable" (onLazyLoad)="onLazyLoad($event)"
           [filterDelay]="0" [loading]="loading"
           [selectionMode]="config.multiSelectable || config.checkboxes ? 'multiple' : (config.singleSelectable ? 'single' : null)"
           [(selection)]="selectedRows" [metaKeySelection]="config.multiSelectable ? true : null"
           styleClass="dyn-table"
           stateStorage="local" [stateKey]="stateKey"
           [autoLayout]="autoLayout"
           responsiveLayout="scroll"
           (onHeaderCheckboxToggle)="checkboxSelectAll($event)"
           (onRowSelect)="onRowSelect($event)"
           (onRowReorder)="onRowReorder($event)"
           (onRowUnselect)="onRowUnselect($event)"
           (onSort)="checkSort($event)"
           (onPage)="resetSelection()">

    <!-- headers delle colonne (con eventuale colgroup) -->
    <ng-template pTemplate="header" let-columns>

      <!-- qui ci sono le testate finte delle colonne  -->
      <tr *ngIf="colGroup" class="zero-expanded-row">
        <th *ngIf="config.reordableRow" style="width: 3em;" class="border-0"></th>
        <th *ngIf="config.checkboxes" style="width: 3em;" class="border-0"></th>
        <th *ngIf="actionsPresent()" class="border-0" [ngStyle]="calculateActionsWidth()"></th>
        <th *ngFor="let col of getColgroupCols()" class="font-weight-bold border-0"></th>
      </tr>

      <!-- qui i raggruppamenti delle colonne -->
      <tr *ngIf="colGroup" class="dyn-table-header-row">
        <th *ngIf="actionsPresent()" class="border-top-0 border-bottom-0"></th>
        <th *ngFor="let colgroup of colGroup" [attr.colspan]="colgroup.colspan" class="border-top-0 border-bottom-0">
          <div>{{colgroup.label}}</div>
        </th>
      </tr>

      <!-- qui ci sono le testate delle colonne  -->
      <tr class="dyn-table-header-row">
        <th *ngIf="config.reordableRow" style="width: 3em;"></th>
        <th *ngIf="rowSpanMetadata" [ngStyle]="getColumnStyle(rowSpanMetadata)">{{rowSpanMetadata.header}}</th>
        <th *ngIf="expandedFields && expandedFields.length > 0"></th>
        <th *ngIf="config.checkboxes" style="width: 3em;">
          <p-tableHeaderCheckbox *ngIf="!config.singleSelectable && config.chkboxSelectAllBtn"></p-tableHeaderCheckbox>
          <span style="white-space: nowrap;">{{ config.checkboxesHeader }}&nbsp;
          <i class="fas fa-info-circle input-icon-right cursor-pointer"
            pTooltip="{{ config.checkboxesInfo }}" tooltipPosition="top"></i></span>
        </th>
        <th *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.name : ''" class="font-weight-bold"
            [ngStyle]="getColumnStyle(col)">
          <div class="pre-line">
            {{ col.label }}
            <p-sortIcon *ngIf="col.sortable" [field]="col.name"></p-sortIcon>
          </div>
        </th>
        <th *ngIf="actionsPresent()" [ngStyle]="calculateActionsWidth()">{{config.labels.azioniHeader}}</th>
      </tr>

      <!-- riga filtri (lato client) x colonna -->
      <tr class="text-center" *ngIf="config.clientSideFilters && !config.serverSideFilters">
        <th *ngIf="config.reordableRow" style="width: 3em;"></th>
        <th *ngIf="expandedFields && expandedFields.length > 0"></th>
        <th *ngIf="config.checkboxes"></th>
        <th *ngFor="let col of columns">
          <form [formGroup]="formFilter" novalidate>

            <input pInputText type="search" *ngIf="col.searchable && col.searchType === DynTableSearchType.TEXT"
                   (input)="dynTable.filter($event.target['value'], col.name, (col.searchMethod ? col.searchMethod : 'contains'))"
                   [placeholder]="col.searchPh" class="ui-column-filter w-100"
                   [formControlName]="col.name">

            <input pInputText type="number" *ngIf="col.searchable && col.searchType === DynTableSearchType.NUMBER"
                   (input)="dynTable.filter($event.target['value'], col.name, (col.searchMethod ? col.searchMethod : 'contains'))"
                   [placeholder]="col.searchPh" class="ui-column-filter w-100"
                   [formControlName]="col.name">

            <ng-select *ngIf="col.searchable && col.searchType === DynTableSearchType.BOOLEAN"
                       [items]="col.searchOptions" (change)="searchBoolean($event?.value, col.name)"
                       bindValue="value" bindLabel="label"
                       [placeholder]="col.searchPh" class="ui-column-filter w-100"
                       [formControlName]="col.name">
            </ng-select>

            <p-inputMask *ngIf="col.searchable && col.searchType === DynTableSearchType.DATE"
                         (onInput)="searchFromMask($event.target?.value, col.name, col.searchMethod)" [placeholder]="col.searchPh"
                         styleClass="ui-column-filter w-100" mask="99/99/9999"
                         [formControlName]="col.name">
            </p-inputMask>

            <p-inputMask *ngIf="col.searchable && col.searchType === DynTableSearchType.TIME"
                         (onInput)="searchFromMask($event.target?.value, col.name, col.searchMethod)" [placeholder]="col.searchPh"
                         styleClass="ui-column-filter w-100" mask="99:99"
                         [formControlName]="col.name">
            </p-inputMask>

            <p-inputMask type="text" *ngIf="col.searchable && col.searchType === DynTableSearchType.CURRENCY"
                         (onInput)="searchFromMask($event.target?.value, col.name, col.searchMethod)" [placeholder]="col.searchPh"
                         styleClass="ui-column-filter w-100" mask="€000.000.000,00"
                         [formControlName]="col.name">
            </p-inputMask>

            <ng-select *ngIf="col.searchable && col.searchType === DynTableSearchType.SELECT"
                       [items]="col.searchOptions" (change)="dynTable.filter($event?.value, col.name, 'equals')"
                       bindValue="value" bindLabel="label" [placeholder]="col.searchPh" class="ui-column-filter w-100"
                       [formControlName]="col.name">
            </ng-select>

            <p-multiSelect *ngIf="col.searchable && col.searchType === DynTableSearchType.MULTISELECT"
                           [options]="col.searchOptions" [filterPlaceHolder]="col.searchPh"
                           (onChange)="onMultiselectChange($event, col.name)" optionLabel="label" styleClass="ui-column-filter w-100"
                           [formControlName]="col.name">
              <ng-template let-option pTemplate="item">
                <div class="ui-multiselect-option">
                  <span>{{option.label}}</span>
                </div>
              </ng-template>
            </p-multiSelect>

          </form>
        </th>
        <th *ngIf="actionsPresent()"></th>
      </tr>

    </ng-template>

    <!-- righe tabella -->
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">

      <tr *ngIf="config.checkboxes || (!config.checkboxes && !config.reordableRow && !config.colored)" [pSelectableRow]="rowData"
          [pSelectableRowIndex]="rowData.index" (click)="handler($event, rowData)">
        <!-- eventuale rowspan -->
        <ng-template
            [ngIf]="rowSpanMetadata && config.rowspanField && rowSpanMetadata[rowData[config.rowspanField]].index === rowIndex">
          <td [attr.rowspan]="rowSpanMetadata[rowData[config.rowspanField]].size" [ngStyle]="rowSpanMetadata.style">
            <span [ngClass]="'custom-span'"
                  [innerHTML]="sanitizer.bypassSecurityTrustHtml(rowSpanMetadata[rowData[config.rowspanField]].value)">
            </span>
          </td>
        </ng-template>
        <ng-template [ngTemplateOutlet]="blockBody"></ng-template>
      </tr>

      <!-- riga colorata -->
      <tr *ngIf="!config.checkboxes && !config.reordableRow && config.colored" [pSelectableRow]="rowData"
        [pSelectableRowIndex]="rowData.index" (click)="handler($event, rowData)" [style]="rowData.color"
        [ngClass]="config.rowClickAction ? 'cursor-pointer' : ''">
        <ng-template [ngTemplateOutlet]="blockBody"></ng-template>
      </tr>

      <!-- righe riordinabili -->
      <tr *ngIf="config.reordableRow" [pReorderableRow]="rowIndex">
        <td>
          <i class="pi pi-bars grab-cursor" pReorderableRowHandle></i>
        </td>
        <ng-template [ngTemplateOutlet]="blockBody"></ng-template>
      </tr>

      <!-- blocco body con actions/dati e tutta la struttura riusabile -->
      <ng-template #blockBody>
        <td *ngIf="expandedFields && expandedFields.length > 0" class="dyn-table-column">
          <!-- azione speciale expander (se ci sono expandedFields) -->
          <div class="float-center pt-2 pr-2 text-center">
            <a href="#" [pRowToggler]="rowData" (click)="actionRowHandler($event, rowData)">
              <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
            </a>
          </div>
        </td>

        <!-- colonna checkbox -->
        <td class="dyn-table-column" style="width: 3em; text-align: center;" *ngIf="config.checkboxes">
          <p-tableCheckbox #tableCheckbox [value]="rowData" (click)="handler($event, rowData)"></p-tableCheckbox>
        </td>

        <!-- colonne standard -->
        <td *ngFor="let col of columns" class="dyn-table-column" [pEditableColumn]="col.editable && !rowData.editDisabled"
            [id]="'cell-editor-' + col.name + '-' + rowIndex"
            [ngStyle]="{ 'background-color': col.bgColor ? rowData[col.bgColor] : 
            (rowData.coloreScenario && rowData.tipoScenario == 'LIMITE' && (col.name == 'scenarioMin' || col.name == 'scenarioMax') ? '#b30000' : null)}">
            <!-- TODO - Controllo che non va bene fatto qui ma introdotto per mancanza di tempo -->

          <!-- colonna "normale" senza type e non editabile -->
          <div *ngIf="!col.type && !col.editable" [ngStyle]="col.cellStyle">
            <span title="{{rowData[col.name]}}" [ngStyle]="col.cellStyle ? col.cellStyle : { 'font-weight': rowData.coloreUtiliPerdite ? 'bold' : '400', 
              'color': (rowData.coloreUtiliPerdite ? (rowData[col.name].startsWith('-') ? '#b30000' : 'mediumblue') : 'black') }">{{rowData[col.name]}}</span>
          </div>

          <!-- colonna con type number -->
          <div *ngIf="col.type && col.type == DynTableColType.NUMBER2DECIMAL" [ngStyle]="col.cellStyle">
            <span [ngStyle]="col.cellStyle ? col.cellStyle : { 'font-weight': rowData.coloreUtiliPerdite ? 'bold' : '400', 
              'color': (rowData.coloreUtiliPerdite ? (rowData[col.name] >= 0 ? 'mediumblue' : '#b30000') : 'black') }">
              {{rowData[col.name] | number : '1.2-2'}}</span>
          </div>

          <!-- colonna con type percentuale -->
          <div *ngIf="col.type && col.type == DynTableColType.PERC_NUMBER2DECIMAL" [ngStyle]="col.cellStyle">
            <span [ngStyle]="col.cellStyle ? col.cellStyle : { 'font-weight': rowData.coloreUtiliPerdite ? 'bold' : '400', 
              'color': (rowData.coloreUtiliPerdite ? (rowData[col.name] >= 0 ? 'mediumblue' : '#b30000') : 'black') }">
              {{rowData[col.name] | number : '1.2-2'}} %</span>
          </div>

          <!-- colonna con type number -->
          <div *ngIf="col.type && col.type == DynTableColType.NUMBER4DECIMAL" [ngStyle]="col.cellStyle">
            <span [ngStyle]="col.cellStyle ? col.cellStyle : { 'font-weight': rowData.coloreUtiliPerdite ? 'bold' : '400',
              'color': (rowData.coloreUtiliPerdite ? (rowData[col.name] >= 0 ? 'mediumblue' : '#b30000') : 'black') }">
              {{rowData[col.name] | number : '1.4-4'}}</span>
          </div>

          <!-- colonna scenario previsionale -->
          <!-- TODO - Queste tabelle andrebbero rifatte come tabelle normali -->
          <div *ngIf="col.type && col.type == DynTableColType.SCENARIO_PREVISIONALE" [ngStyle]="col.cellStyle">
            <span [ngStyle]="col.cellStyle ? col.cellStyle : { 'font-weight': rowData.coloreScenario || rowData.coloreUtiliPerdite ? 'bold' : '400',
              'color': rowData.coloreScenario && rowData.tipoScenario == 'LIMITE' && (col.name == 'scenarioMin' || col.name == 'scenarioMax') ? 'white' : (rowData.coloreUtiliPerdite ? 
              (rowData[col.name].startsWith('-') ? '#b30000' : 'mediumblue') : 'black') }">
              {{rowData[col.name]}}</span>
          </div>

          <!-- colonna utili perdite -->
          <div *ngIf="col.type && col.type == DynTableColType.UTILI_PERDITE" [ngStyle]="col.cellStyle">
            <span [ngStyle]="{ 'color': rowData[col.name] < 0 ? '#b30000' : 'mediumblue' }">
              <b>{{rowData[col.name] | number : '1.2-2'}}</b></span>
          </div>

          <!-- colonna con type date -->
          <div *ngIf="col.type && col.type == DynTableColType.DATE" [ngStyle]="col.cellStyle">
            <span>{{rowData[col.name] | date: 'dd/MM/yyyy'}}</span>
          </div>

          <!-- colonna tooltip -->
          <div *ngIf="col.type && col.type == DynTableColType.TOOLTIP" [ngStyle]="col.cellStyle">
            <span pTooltip="{{col.tooltip}}">{{rowData[col.name]}}</span>
          </div>

          <!-- colonna con tipo particolare -->
          <div *ngIf="col.type && col.type !== DynTableColType.ROUTE && col.type !== DynTableColType.BADGE
                      && col.type !== DynTableColType.DOTS && !col.editable" [ngStyle]="col.cellStyle">
            <span [ngClass]="'custom-span'"
                  (click)="deviceService && !deviceService.isDesktop() ? showCustomDialog(rowData[col.name]) : null"
                  [innerHTML]="service.renderField(col, rowData[col.name])">{{rowData[col.name]}}
            </span>
          </div>

          <!-- colonna di tipo 'dots' (pallino rosso o verde) -->
          <div *ngIf="col.type && col.type == DynTableColType.DOTS && !col.editable" [ngStyle]="col.cellStyle">
            <span [ngClass]="'custom-span'"
                  (click)="deviceService && !deviceService.isDesktop() ? showCustomDialog(rowData[col.name]) : null"
                  [innerHTML]="service.renderField(col, rowData[col.name])">
            </span>
          </div>

          <!-- colonna di tipo 'badge' -->
          <div *ngIf="col.type && col.type == DynTableColType.BADGE && !col.editable" [ngStyle]="col.cellStyle">
            <span [ngClass]="'custom-span'"
                  (click)="deviceService && !deviceService.isDesktop() ? showCustomDialog(rowData[col.name]) : null"
                  [innerHTML]="service.renderField(col, rowData[col.name])">
            </span>
          </div>

          <!-- colonna di tipo 'checkable' -->
          <div *ngIf="col.type && col.type == DynTableColType.CHECKABLE && !col.editable && rowData[col.name]" [ngStyle]="col.cellStyle">
            <div class="float-left">
              <p-checkbox [value]="rowData[col.name]"
                          [disabled]="notSameRowChecked ? checkDisabledCheckedCell(rowIndex, col.name) : false"
                          (onChange)="checkValueColumn($event, rowIndex, rowData[col.name], col.name, rowData)">
              </p-checkbox>
              &nbsp;
            </div>
            <div class="float-left">
              <span title="{{rowData[col.name]}}">{{rowData[col.name]}}</span>
            </div>
          </div>

          <!-- colonna con link che apre nuovo tab -->
          <div *ngIf="col.type == 'route' && !col.editable" [ngStyle]="col.cellStyle">
            <span [ngClass]="col.customCssClass != null ? col.customCssClass : 'custom-span'"
                  (click)="routeSelectedValue.emit({value: rowData[col.name], row: rowData})"
                  [innerHTML]="service.renderField(col, rowData[col.name])">
            </span>
          </div>

          <!-- colonna con link che apre nuovo tab -->
          <div *ngIf="col.type == 'progress'" [ngStyle]="col.cellStyle">
            <p-progressBar [value]="rowData[col.name]" [showValue]="true"></p-progressBar>
          </div>

          <p-dialog *ngIf="checkColumnType(col)" (visibleChange)="dialogCustom.visible = false" #dialogCustom
                    [resizable]="false" [style]="{'min-height': 'auto'}" [appendTo]="'body'">
            <b>{{ col.label }}</b>:<br/>
            <span style="cursor:default" [innerHTML]="service.renderField(col, rowData[col.name])"></span>
          </p-dialog>

          <!-- colonna che risulta editabile da config ma che in visualizzazione deve comparire "normale" (campo removeEditable = true) -->
          <div *ngIf="!col.type && (col.editable && rowData.removeEditable)" [ngStyle]="col.cellStyle">
            <span title="{{rowData[col.name]}}">{{rowData[col.name]}}</span>
          </div>

          <!-- colonna editabile -->
          <p-cellEditor *ngIf="col.editable && !rowData.removeEditable">
            <ng-template pTemplate="input">
              <input *ngIf="!col.editType || col.editType === DynTableColEditType.TEXT"
                     class="form-control form-control-head w-100 text-black-50" pInputText type="text"
                     [(ngModel)]="rowData[col.name]" (change)="editedCell(rowIndex, col, rowData[col.name])"
                     [disabled]="rowData.editDisabled && (!config.listNotEditableFields || config.listNotEditableFields.includes(col.name))"
                     (blur)="onBlur(rowIndex, col, $event?.value)"
                     (keydown.tab)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])"
                     (keydown.enter)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])">
              <input *ngIf="col.editType === DynTableColEditType.NUMBER"
                     class="form-control form-control-head w-100 text-black-50" type="text"
                     [(ngModel)]="rowData[col.name]" (change)="editedCell(rowIndex, col, rowData[col.name])"
                     (blur)="onBlur(rowIndex, col, $event?.value)" [disabled]="rowData.editDisabled"
                     editNumeric [decimals]="col.editDecimals"
                     (focusin)="rowData[col.name] === 0 ? rowData[col.name] = null : rowData[col.name] = rowData[col.name]"
                     (keydown.tab)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])"
                     (keydown.enter)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])">
              <ng-select *ngIf="col.editType === DynTableColEditType.SELECT"
                         [disabled]="rowData.editDisabled && (!config.listNotEditableFields || config.listNotEditableFields.includes(col.name))"
                         [items]="col.editOptions" (change)="editedCell(rowIndex, col, rowData[col.name])"
                         bindValue="value" bindLabel="label" [placeholder]="col.searchPh" class="ui-column-filter"
                         [(ngModel)]="rowData[col.name]" appendTo="body"
                         (keydown.tab)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])"
                         (keydown.enter)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])">
                <ng-template ng-option-tmp let-item="item">
                  <div title="{{item.label}}">{{item.label}}</div>
                </ng-template>
              </ng-select>
              <ng-select *ngIf="col.editType === DynTableColEditType.BOOLEAN"
                         [disabled]="rowData.editDisabled && (!config.listNotEditableFields || config.listNotEditableFields.includes(col.name))"
                         [items]="col.editOptions" (change)="editedCell(rowIndex, col, rowData[col.name])"
                         bindValue="value" bindLabel="label" appendTo="body"
                         [placeholder]="col.searchPh" class="ui-column-filter"
                         [(ngModel)]="rowData[col.name]" (blur)="onBlur(rowIndex, col, $event?.value)"
                         (keydown.tab)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])"
                         (keydown.enter)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])">
              </ng-select>
              <p-calendar *ngIf="col.editType === DynTableColEditType.CALENDAR" [monthNavigator]="true"
                          [yearNavigator]="true" yearRange="2001:2040" dateFormat="dd/mm/yy" [showIcon]="true"
                          [showButtonBar]="true" [showTime]="true"
                          [baseZIndex]="3002" [appendTo]="deviceService.isMobile() ? 'body' : null"
                          [touchUI]="deviceService.isMobile()" [(ngModel)]="rowData[col.name]"
                          (onSelect)="editedCell(rowIndex, col, $event?.value)" [disabled]="rowData.editDisabled"
                          (keydown.tab)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])"
                          (keydown.enter)="setFocus($event, 'cell-editor-' + col.name + '-' + (rowIndex + 1)); onBlur(rowIndex, col, rowData[col.name])">
              </p-calendar>
            </ng-template>
            <ng-template pTemplate="output"
                         *ngIf="col.editType !== DynTableColEditType.SELECT && col.editType !== DynTableColEditType.BOOLEAN">
              <div class="form-control form-control-head" [innerHTML]="service.renderField(col, rowData[col.name])"></div>
            </ng-template>
            <ng-template pTemplate="output"
                         *ngIf="col.editType === DynTableColEditType.SELECT || col.editType === DynTableColEditType.BOOLEAN">
              <div class="form-control form-control-head"
                   [innerHTML]="service.renderField(col, getSelectLabel(col.editOptions, rowData[col.name]))"
                   style="overflow: hidden; white-space: nowrap;"></div>
            </ng-template>
          </p-cellEditor>

        </td>

        <!-- se ci sono campi nell'expander mostro l'action ">" -->
        <td *ngIf="actionsPresent()" class="dyn-table-column" [ngClass]="config && config.colored ? 'white-bg' : null">
          <div class="d-flex flex-wrap justify-content-center" [ngStyle]="calculateActionsWidth()">
            <!-- colonna azioni -->
            <ng-container *ngFor="let action of actions">
              <!-- azione standard (non expander) -->
              <!-- N.B.: per poter gestire un particolare tooltip "dinamico" in una action usare la convenzione:
                action.type + | + (testo tooltip) -->
              <div *ngIf="!(action.hidden && rowData[action.hidden]) && !action.splitButton" class="float-left text-center">
                <button [disabled]="action.disabled ? rowData[action.disabled]: false"
                        (click)="handlerAction($event, action, rowData)" class="btn btn-sm {{action.cls}} action-btn-width"
                        pTooltip="{{(rowData.actionTooltip && rowData.actionTooltip.split('|')[0] == action.type) ?
                          rowData.actionTooltip.split('|')[1] : action.tooltip}}" style="margin: 2px" type="button"
                        [tooltipPosition]="action.tooltipLarge ? 'right' : 'top'"
                        [tooltipStyleClass]="action.tooltipLarge ? 'tooltip-large' : ''">
                  <span *ngIf="action.stackedIcons" class="fa-stack" style="font-size: 0.52em;">
                    <i *ngFor="let stackedIcon of action.stackedIcons"
                       class="fa {{stackedIcon}} fa-stack-1x customStackIcon"></i>
                  </span>
                  <i *ngIf="!action.stackedIcons && action.icon" class="{{ action.icon }}"></i>
                </button>
              </div>

              <!-- split button per le row action -->
              <div *ngIf="action.splitButton && !(action.hidden && rowData[action.hidden])">
                <p-splitButton icon="{{action.icon}}" (onClick)="action.onClick(action.type, rowData)"
                               [appendTo]="'body'"
                               (onDropdownClick)="actionHandler($event, action.type, rowData);onMenuClick($event, rowData)"
                               [model]="action.items" pTooltip="{{ action.tooltip }}"
                               [tooltipPosition]="action.tooltipLarge ? 'right' : 'top'"
                               [tooltipStyleClass]="action.tooltipLarge ? 'tooltip-large' : ''">
                </p-splitButton>
              </div>
            </ng-container>
          </div>
        </td>

        <!-- sottogruppi -->
        <tr *ngIf="rowGroup && rowGroup.key == rowData[rowGroup.key] && rowGroup[rowData.groupBy].index === rowIndex">
          <td *ngFor="let footerField of getSumGrouped(rowData.groupBy); let i = index"
              style="box-sizing: border-box;padding: .25em .5em;font-weight: bold;" [ngStyle]="footerField.style">
            {{footerField.hasFooter ? footerField.value : ""}}
            {{(!footerField.hasFooter && i == 0) ? config.labels.totali : ""}}
          </td>
        </tr>
      </ng-template>


    </ng-template>

    <!-- pulsante nuova riga + eventuale pulsante "custom action" -->
    <ng-template *ngIf="config.addRowTable || config.showCustomBtn" pTemplate="summary">
      <div class="text-left">
        <div class="btn-group">
          <button *ngIf="config.addRowTable" type="button" class="btn btn-primary"
                  pTooltip="{{config.addRowBtnTooltip}}" tooltipPosition="top"
                  (click)="addRowTable(columns)" [disabled]="addButtonDisabled">
            <i class="fas fa-fw fa-plus"></i>
          </button>
          <button *ngIf="config.showCustomBtn" type="button" class="btn btn-primary"
                  pTooltip="{{config.customBtnTooltip}}" tooltipPosition="top"
                  (click)="customBtnClicked.emit()" [disabled]="customButtonDisabled">
            <i class="fa-fw" [ngClass]="config.customBtnIconClass"></i>
          </button>
        </div>
      </div>
    </ng-template>

    <!-- expander della tabella (ripresa da dyn-table) -->
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
      <tr class="zero-expanded-row">
        <!-- non rimuovere, ci mantiene l'ordine della zebra  -->
      </tr>
      <tr class="expanded-row">
        <td class="expanded-td" [attr.colspan]="config.checkboxes ? columns.length + 3 : (actionsPresent() ? columns.length + 2 : columns.length + 1)">
          <div class="container ml-2">
            <!-- se sono raggruppati in tab -->
            <div [@rowExpansionTrigger]="'active'" class="row">
              <div *ngFor="let group of getExpandedGroups()" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-left mb-2">
                <div class="mt-1 font-weight-bold"><i>{{group}}</i></div>
                <hr class="mt-1 mb-1"/>
                <div *ngFor="let col of getExpandedFields(group); let i = index" [ngStyle]="col.style">
                  <div *ngIf="!col.type" [ngStyle]="col.cellStyle">
                    <span [ngClass]="col.customCssClass != null ? col.customCssClass : 'custom-span'"
                          [ngStyle]="{cursor: col.dialog ? 'pointer' : 'default'}">
                      <span class="font-weight-bold" *ngIf="col && col.label"> {{col.label}}:&nbsp;</span>
                      <span [innerHTML]="service.renderField(col, rowData[col.name])"></span>
                    </span>
                  </div>
                  <div *ngIf="col.type && col.type !== 'download'" [ngStyle]="col.cellStyle">
                    <span [ngClass]="col.customCssClass != null ? col.customCssClass : 'custom-span'"
                          [ngStyle]="{cursor: col.dialog ? 'pointer' : 'default'}">
                      <span class="font-weight-bold" *ngIf="col && col.label"> {{col.label}}:&nbsp;</span>
                      <span [innerHTML]="service.renderField(col, rowData[col.name])"></span>
                    </span>
                  </div>
                  <div *ngIf="col.type && col.type == 'download'" [ngStyle]="col.cellStyle">
                    <div *ngFor="let elem of rowData[col.valueExpander]; let n = index" [ngStyle]="col.style">
                      <span [ngClass]="col.customCssClass != null ? col.customCssClass : 'custom-span'"
                            (click)="downloadSelectedValue.emit({value: elem.value, index: n})"
                            [innerHTML]="service.renderField(col, elem.name)">
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- se non sono raggruppati in tab -->
              <div class="text-left col-12">
                <div *ngFor="let col of getExpandedFields()" [ngStyle]="col.style">
                  <div *ngIf="!col.type" [ngStyle]="col.cellStyle">
                    <span [ngClass]="col.customCssClass != null ? col.customCssClass : 'custom-span'"
                          [ngStyle]="{cursor: col.dialog ? 'pointer' : 'default'}">
                      <span class="font-weight-bold" *ngIf="col && col.label">{{col.label}}:&nbsp;</span>
                      <span [innerHTML]="service.renderField(col, rowData[col.name])"></span>
                    </span>
                  </div>
                  <div *ngIf="col.type" [ngStyle]="col.cellStyle">
                    <span [ngClass]="col.customCssClass != null ? col.customCssClass : 'custom-span'"
                          [ngStyle]="{cursor: col.dialog ? 'pointer' : 'default'}">
                      <span class="font-weight-bold" *ngIf="col && col.label">{{col.label}}:&nbsp;</span>
                      <span [innerHTML]="service.renderField(col, rowData[col.name])"></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- footer tabella per riga totali -->
    <ng-template pTemplate="footer">
      <tr *ngIf="hasFooterFields()">
        <td *ngFor="let footerField of getFooterFields(); let i = index"
            style="text-align: center;box-sizing: border-box;padding: .25em .5em;" [ngStyle]="footerField.style">
          {{footerField.hasFooter ? footerField.value : ""}}
          {{(!footerField.hasFooter && i == 0) ? config.labels.totali : ""}}
        </td>
      </tr>
    </ng-template>

  </p-table>
  <!-- numeri di pagina -->
  <p-footer>
    <div class="pb-2 text-center" *ngIf="showFooter && config.paginator">
      <span>
        {{ config.labels.mostrati }} {{ (dynTable.first < 0 ? 1 : (dynTable.first + 1)) }} -
        {{ ((dynTable.first + dynTable.rows) > total ? (total ? total : (data?.length)) : (dynTable.first + dynTable.rows)) }}
        {{ config.labels.di }} <strong> {{ total ? total : (data?.length) }}</strong>
      </span>
    </div>
  </p-footer>
</div>
